import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../../../services/client.service';
import { UserService } from '../../../services/user.service';
import { AppointmentService } from '../../../services/appoinment.service';
import { PetService } from '../../../services/pet.service';
import { ClinicService } from '../../../services/clinic.service';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-appointments',
  templateUrl: './appointments.component.html',
})
export class AppointmentsComponent implements OnChanges {

  private _client_no: number = 0;
  private _pet_no: number = 0;
  filterType: string = 'pet';
  searchTerm: string = '';

  setFilterType(type: string) {
    this.filterType = type;
    this.getAppts();
   
  }
  onPetChange(event: any) {
    this.searchTerm = event.target.value;
    if (this.searchTerm === '') {
      this.getAppts(); // Reload all appointments
    } else {
      if (this.appointmentService.appts_petsclients) {
        this.appointmentService.appts_petsclients = this.appointmentService.appts_petsclients.filter(appointment => appointment.pet_no === parseInt(this.searchTerm));
      }
    }
  }

  @Input() set client_no(value: number) {
    this._client_no = value;
    // this.petService.getPetCheckIn(this.petService.current_client_no).then(() => { });
  }


  get client_no(): number {    
    return this._client_no;
  }

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    // this.petService.getPetCheckIn(this.petService.current_client_no).then(() => { });
  }


  get pet_no(): number {
    return this._pet_no;
  }

  @Input() set type(value: string) {
    this.filterType = value;
    // this.petService.getPetCheckIn(this.petService.current_client_no).then(() => { });
  }

  constructor(
    public clientService: ClientService,
    public userService: UserService,
    public appointmentService: AppointmentService,
    public petService: PetService,
    public clinicService: ClinicService,
    private route: ActivatedRoute
  ) {

    $('#modalNewFamilyApptDetail').on('hidden.bs.modal', () => {
      this.getAppts()
    });
 
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.client_no || changes.pet_no) {
      this.getAppts()
    }

    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
        
        this.getAppts()
        
      }); 
  }
 

  getAppts(){

    if(this.pet_no == 0  || this.pet_no == undefined || this.pet_no == null || this.filterType === 'client'){
      this.appointmentService.GetAppts_byPetNoClientNo(0 , this.client_no).then(() => { }); 
    } 
    else{
      this.appointmentService.GetAppts_byPetNoClientNo(this.pet_no , 0).then(() => { }); 
    } 
  }

  // Filters
  filterDate: string = '';
  filterPetNo: number | null = null;
  filterClientNo: number | null = null;


  resetFilters(){
    this.filterDate = '';
    this.filterPetNo = null;
    this.filterClientNo = null;
    this._pet_no = this.pet_no;
    this._client_no = this.client_no;
    this.getAppts();
  }

  add() {
    this.userService.selectedGenericVar(true);
    this.appointmentService.notifyWorkApptFunction();
    $('#modalNewFamilyAppt').modal('toggle') 
  }

  edit(item) {
    this.clientService.appt = item;
    $('#modalNewFamilyAppt').modal('toggle')
  } 

  isAppointmentDatePassed(appointmentDateStr: string): boolean { 
    const appointmentDate = new Date(appointmentDateStr);
    const currentDate = new Date(); 
    appointmentDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0); 
    return appointmentDate < currentDate;
}

  openApptDetBtn(appt_id){
    this.ApptDetailInit(appt_id)
  }

  ApptDetailInit(appt_id){
    this.appointmentService.GetApptByApptID(appt_id).then(()=>{ 
      this.appointmentService.complete_appt_model.dropoff_time = this.getTime_Military(this.appointmentService.complete_appt_model.dropoff_time)
      this.appointmentService.pickupTime = this.getTime_Military(this.appointmentService.complete_appt_model.pickup_time)
      this.appointmentService.pickupDate = this.getFormattedDate(this.appointmentService.complete_appt_model.pickup_time)
      this.appointmentService.complete_appt_model.appointment_date = this.getFormattedDate(this.appointmentService.complete_appt_model.appointment_date)
      this.appointmentService.notifyApptDetailsFunction();
    })

    this.appointmentService.GetApptSubByApptID(appt_id).then(()=>{
        //added for a TAG
        this.clinicService.reserveTagList = []
      //Add blank data on tag
      this.appointmentService.complete_apptsub_model.forEach(item=>{
        const newData = {
          id: 0,
          tag_no: '',
          pet_no: item.pet_no,
          pet_name: item.pet_name,
          location: '',
          sublocation: 0,
          duration: 1,
          date: '',
          status: 'R'
        }; 
        this.clinicService.reserveTagList.push(newData)
        
        this.petService.GetPetTagHistbyPetNoDate(item.pet_no,item.appointment_date).then((tagitem:any) =>{  
          let id = tagitem?.id ?? null; 
          let tag_no = tagitem?.tag_no ?? null; 
          let location = tagitem?.location ?? null; 
          let sublocation = tagitem?.sublocation ?? null; 
          
          let c_restag = this.clinicService.reserveTagList.find(item_C => item_C.pet_no == tagitem.pet_no);
          if (c_restag) {
            c_restag.id = id;
            c_restag.tag_no = tag_no;
            c_restag.location = location;
            c_restag.sublocation = sublocation;
          }
        }) 
         
      }) 

      
    })

    //this.appointmentService.selected_appt_resource[2] = this.extractAvailableHours(timestr);  
    
    $('#modalNewFamilyApptDetail').modal('toggle') 
  }

  getTime_Military(datetimestr){  
    const date = new Date(datetimestr);
    const options: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false };
    const formattedTime = date.toLocaleTimeString('en-US', options);
  
    return formattedTime
  }

  getFormattedDate(datetimestr){
      const date = datetimestr
      const date_datePart = date.split(" ")[0]; // Extract the date portion
      const parts = date_datePart.split("/"); // Split date into parts [MM, DD, YYYY]
      const CombinedParts = `${parts[2]}-${parts[0]}-${parts[1]}`; // Format as YYYY-MM-DD
      return(CombinedParts);
  }
}
